import(/* webpackMode: "eager" */ "/opt/reddo-seo/web/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/reddo-seo/web/src/components/DynamicImageV2.js");
